import React, { useEffect, useRef } from "react";

export default function AccessDeniedModal({
  open,
  onLogout,
  onClose,
  title = "Access denied",
  message = "You don't have permission to view this page. If you think this is a mistake, contact your admin or log out and sign in with a different account.",
}) {
  const dialogRef = useRef(null);

  // Close on Escape
//   useEffect(() => {
//     if (!open) return;
//     const handleKeyDown = (e) => {
//       if (e.key === "Escape") onClose?.();
//     };
//     document.addEventListener("keydown", handleKeyDown);
//     return () => document.removeEventListener("keydown", handleKeyDown);
//   }, [open, onClose]);

  // Focus the dialog when it opens
//   useEffect(() => {
//     if (open && dialogRef.current) {
//       dialogRef.current.focus();
//     }
//   }, [open]);

  if (!open) return null;

  return (
    <div
      style={styles.overlay}
    //   onClick={onClose}
      aria-hidden="false"
    >
      <div
        ref={dialogRef}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="access-denied-title"
        aria-describedby="access-denied-message"
        tabIndex={-1}
        style={styles.card}
        onClick={(e) => e.stopPropagation()}
      >
        {/* <button
          type="button"
          aria-label="Close"
          onClick={onClose}
          style={styles.closeButton}
        >
          <CloseIcon />
        </button> */}

        <div style={styles.iconWrap}>
          <LockIcon />
        </div>

        <h2 id="access-denied-title" style={styles.title}>
          {title}
        </h2>

        <p id="access-denied-message" style={styles.message}>
          {message}
        </p>

        <div style={styles.actions}>
          {/* <button
            type="button"
            onClick={onClose}
            style={styles.secondaryButton}
          >
            Go back
          </button> */}
          <button
            type="button"
            onClick={onLogout}
            style={styles.primaryButton}
          >
            Log out
          </button>
        </div>
      </div>
    </div>
  );
}

function LockIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect
        x="5"
        y="11"
        width="14"
        height="9"
        rx="2"
        stroke="#B3261E"
        strokeWidth="1.8"
      />
      <path
        d="M8 11V7.5C8 5.01 10.01 3 12.5 3C14.79 3 16.69 4.69 16.95 6.9"
        stroke="#B3261E"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <circle cx="12" cy="15.5" r="1.4" fill="#B3261E" />
    </svg>
  );
}

function CloseIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M6 6L18 18M6 18L18 6"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(15, 15, 17, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    padding: 16,
  },
  card: {
    position: "relative",
    width: "100%",
    maxWidth: 360,
    background: "#ffffff",
    borderRadius: 16,
    border: "1px solid #ECEAE6",
    boxShadow: "0 24px 48px -12px rgba(0,0,0,0.25), 0 0 1px rgba(0,0,0,0.04)",
    padding: "32px 28px 24px",
    textAlign: "center",
    outline: "none",
    animation: "none",
  },
  closeButton: {
    position: "absolute",
    top: 14,
    right: 14,
    width: 28,
    height: 28,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
    border: "none",
    borderRadius: 8,
    color: "#8A8783",
    cursor: "pointer",
  },
  iconWrap: {
    width: 52,
    height: 52,
    borderRadius: "50%",
    background: "#FCEBEB",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 18px",
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    color: "#1A1A18",
    margin: "0 0 8px",
  },
  message: {
    fontSize: 14,
    lineHeight: 1.6,
    color: "#6B6964",
    margin: "0 0 24px",
  },
  actions: {
    display: "flex",
    gap: 10,
    justifyContent: "center",
  },
  secondaryButton: {
    flex: 1,
    height: 40,
    borderRadius: 10,
    border: "1px solid #E2E0DB",
    background: "#FFFFFF",
    color: "#3A3935",
    fontSize: 14,
    fontWeight: 500,
    cursor: "pointer",
  },
  primaryButton: {
    flex: 1,
    height: 40,
    borderRadius: 10,
    border: "none",
    background: "#3F2783",
    color: "#FFFFFF",
    fontSize: 14,
    fontWeight: 500,
    cursor: "pointer",
  },
};